import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/recommendation/manual-02_img1.png'
import _imports_1 from '../../assets/recommendation/manual-02_img2.png'


const _hoisted_1 = {
  class: "main",
  id: "main"
}
const _hoisted_2 = { class: "contents__manual is-color-purple" }
const _hoisted_3 = { class: "section__manual section__manual__mv" }
const _hoisted_4 = { class: "inner__manual" }
const _hoisted_5 = { class: "mv__manual" }
const _hoisted_6 = { class: "section__manual section__manual__default section__manual__colored" }
const _hoisted_7 = { class: "img__manual" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "ttl__h1__manual" }, "上手にスマホで撮影するなら基本の写真テク「三分割法」", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_0,
              alt: ""
            }, null, 32)
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "txt__manual" }, "被写体を中央に置いてしまい、どこか味気ない写真に毎回なってしまう…。スマートフォンでも写真の基本はかわりません。一歩グレードアップさせるなら「三分割法」をマスターするのがおすすめです。", -1))
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("section", { class: "section__manual section__manual__default" }, [
        _createElementVNode("div", { class: "inner__manual" }, [
          _createElementVNode("h2", { class: "ttl__h2__manual" }, [
            _createTextVNode("初心者でもプロ級になる"),
            _createElementVNode("br"),
            _createTextVNode("「三分割法」とは？")
          ]),
          _createElementVNode("p", { class: "txt__manual" }, "三分割法とは写真の基本的な構図のひとつ。スマートフォンのカメラには、設定により三分割法に用いる格子線＝グリッドラインを表示する機能もあります。このグリッドラインを被写体の配置目安にすると絶妙なバランスの写真撮影ができて、「これ、プロに撮ってもらったの？」と評価されるかもしれませんよ。")
        ])
      ], -1)),
      _createElementVNode("section", _hoisted_6, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "arrow_box" }, [
          _createTextVNode("まずは実践！"),
          _createElementVNode("br"),
          _createTextVNode("ゲーム感覚で三分割法を体験してみよう！")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
            src: _imports_1,
            alt: ""
          }, null, 32)
        ]),
        _createElementVNode("div", {
          class: "conversion__btn__manual",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoInteractive()))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("a", { href: "" }, "チャレンジ", -1)
        ]))])
      ])
    ])
  ]))
}